import dayjs from "dayjs";
import { useEffect } from "react";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../store/slices/UI";
import Date from "../../../../../UI/GeneralPurpose/Date";

const UIText = {
  "es-CL": { label: "Desde" },
  "en-US": { label: "From date" },
};

export const DateFromId = "mail-from-date";
const id = DateFromId;

const FromDate = () => {
  const { dispatch, UI } = useUIBp();
  const filter = UI.filter ?? "";

  useEffect(() => {
    const fromMatch = filter.match(/\bstartDate:(\d+-\d+-\d+)\b/);
    const fromValue = fromMatch ? fromMatch[1] : "";

    if (fromValue) {
      dispatch(
        UIactions.setField({ id, value: dayjs(fromValue, "DD-MM-YYYY") })
      );
    }
  }, [dispatch, filter]);

  return (
    <Date
      clearOnUnmount
      emptyStart
      {...{ id, UIText, size: 6 }}
    />
  );
};

export default FromDate;
